import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import { Typography, Card, Table, Form, Input, Row, Spin, Col } from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import appLabel from "../../../config/appLabel";
import appStatic from "../../../config/appStatic";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Text, Title } = Typography;

const ViewGLA0800 = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn } = props;
  const { session } = userData;
  const { months, viewEndOfCirclesItems, monthList } = appStatic;
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const [useForm] = Form.useForm();
  const [EndOfCircleDetail, setEndOfCircleDetail] = useState([]);
  const [modalDetail, setModalDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [journalEntryList, setJournalEntryList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  useEffect(() => {
    // console.log(state);
    getDetailById(state);
  }, []);

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${definedApi.DetailEndOfCircle}/${params.key}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        setEndOfCircleDetail(objDetail);

        // ENABLE DELETE BUTTON
        if (BOM.HasPermission("DELETE_GLCLOSURE")) {
          dispatch({
            type: cnt.RIGHT_DELETE_BTN,
          });
        }

        //STOP LOAD
        setIsLoading(false);

        setIsLoading(false);
      }
    });
  };

  // FLOAT METHODS
  function handleOnView() {
    console.log(selectedRow);
    setModalDetail(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      // navigate("/view-gla0200", { state: selectedRow });
      console.log("viewing");
      // showModal();
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const handleOnDelete = () => {
    let action = "Delete  ";
    let label = "Account Closure";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${definedApi.DeleteEndOfCircle}/${state.key}`;

        const body = {
          method: "DELETE",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, appLabel.deleteEndOfCircleMsg);
              navigate("/gla0800");
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/gla0800");
              setIsLoading(false);
            },
          }
        );
      },
      function () {
        // No button
      }
    );
  };

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      cnt.RIGHT_DETAIL_BTN,
      //  cnt.RIGHT_EDIT_BTN
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true} onView={handleOnView} onDelete={handleOnDelete}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent pageTitle={appLabel.viewAccountClosureDetail} pageItems={viewEndOfCirclesItems} />

      <Spin spinning={isLoading} size="large">
        {/* PART 2 DISPLAY CONTENT */}
        <Form form={useForm} layout="vertical" style={{ paddingTop: 20, marginBottom: 50 }}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            <Card
              style={{
                marginBottom: "2%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
            >
              <Row style={{ justifyContent: "space-between" }}>
                <Form.Item label={<Text strong>{appLabel.branch}</Text>}>
                  <Input
                    style={{ width: "30vh", fontWeight: "bold" }}
                    disabled
                    value={EndOfCircleDetail.officeName}
                  />
                </Form.Item>
                <Form.Item label={<Text strong>{appLabel.closureDate}</Text>}>
                  <Input
                    style={{ width: "30vh", fontWeight: "bold" }}
                    disabled
                    value={
                      EndOfCircleDetail?.closingDate
                        ? `${EndOfCircleDetail?.closingDate[2]} ${
                            monthList[EndOfCircleDetail?.closingDate[1] - 1]
                          } ${EndOfCircleDetail?.closingDate[0]}`
                        : "-"
                    }
                  />
                </Form.Item>

                <Form.Item label={<Text strong>{appLabel.closedBy}</Text>}>
                  <Input
                    style={{ width: "30vh", fontWeight: "bold" }}
                    disabled
                    value={EndOfCircleDetail.createdByUsername}
                  />
                </Form.Item>
              </Row>

              <Row style={{ justifyContent: "space-between" }}>
                <Form.Item label={<Text strong>{appLabel.updateBy}</Text>}>
                  <Input
                    style={{ width: "30vh", fontWeight: "bold" }}
                    disabled
                    value={EndOfCircleDetail.lastUpdatedByUsername}
                  />
                </Form.Item>
                <Form.Item label={<Text strong>{appLabel.updateOn}</Text>}>
                  <Input
                    style={{ width: "30vh", fontWeight: "bold" }}
                    disabled
                    value={
                      EndOfCircleDetail?.lastUpdatedDate
                        ? `${EndOfCircleDetail?.lastUpdatedDate[2]} ${
                            monthList[EndOfCircleDetail?.lastUpdatedDate[1] - 1]
                          } ${EndOfCircleDetail?.lastUpdatedDate[0]}`
                        : "-"
                    }
                  />
                </Form.Item>
                <Form.Item label={<Text strong>{appLabel.closureCreationDate}</Text>}>
                  <Input
                    style={{ width: "30vh", fontWeight: "bold" }}
                    disabled
                    value={
                      EndOfCircleDetail?.createdDate
                        ? `${EndOfCircleDetail?.createdDate[2]} ${
                            monthList[EndOfCircleDetail?.createdDate[1] - 1]
                          } ${EndOfCircleDetail?.createdDate[0]}`
                        : "-"
                    }
                  />
                </Form.Item>
              </Row>
              <Row style={{ justifyContent: "space-between" }}>
                <Form.Item label={<Text strong>{appLabel.comments}</Text>}>
                  <Input
                    style={{ width: "30vh", fontWeight: "bold" }}
                    disabled
                    value={EndOfCircleDetail.comments}
                  />
                </Form.Item>
              </Row>
            </Card>
          </Card>
        </Form>

        {/* PART 3 DISPLAY  RECORD STATUS */}
        <RecordStatus authStatus={""} makerID={""} makerDate={""} checkerID={""} checkerDate={""} />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewGLA0800);
